import React from 'react'


export default function Index(props) {
  return (
    <div className="assessment1-container">
      <div className="assessment1-title">
        Directions
      </div>
      <div className="assessment1-content module5-content">
        Now that you’ve served the 6 guests, you notice that your love interest’s eye color is brown. In the following test, you have to show you’re able to think on your feet about their eye color.You’ll get a word representing a color like red, blue, green, brown, and yellow.  But the color of the word won’t match the color of the meaning of the word.  For every color but brown, your task is to select the color of the word.  But when the word’s meaning is the eye color of your love interest, you must select the meaning of the word instead.
      </div>
      <div className="assessment1-wrap">
        <div className="assessment1-content">
          Example:
        </div>

        <div className="assessment1-content font-600 c-blue">
          Red
        </div>

        <div className="assessment1-content">
          <div>The correct answer <span className='c-blue'>is blue</span></div>
          <div>
            Explanation: Since the word doesn't mean "brown", we choose the color of the word meaning of the word.
          </div>
        </div>

        <div className="assessment1-content font-600 c-red">
          Brown
        </div>

        <div className="assessment1-content">
          <div>The correct answer <span className='color-brown'>is brown</span></div>
          <div>
            Explanation: Since the word doesn't mean "brown", we choose the meaning of the word color of the word
          </div>
        </div>

        <div className="assessment1-content" style={{textAlign: 'center', fontWeight: 'bold', marginTop: '20px'}}>
          This module is timed. Tap the 'Get Started' button when you're ready to proceed.
        </div>
        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get started
        </div>
      </div>
    </div>
  )
}
